import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//import img
import suggestionsImg from '../../assets/icons/arrow-circle-full-yellow.svg';
import suggestionsImgContrast from '../../assets/icons/arrow-circle-full-contrast.svg';
import noSearchResultsImg from '../../assets/icons/no-search-results.svg';

const NoSearchResults = ({clang, isHeadingsDetails}) => {
    return (
        <div className="results__no-results headings-results__no-results">
            <h2 className="results__no-results--title">{isHeadingsDetails ? lang[clang].results.no_results_title_headings : lang[clang].results.no_results_title}</h2>
            <div className="results__no-results--separator"></div>
            <img className="results__no-results--img" src={noSearchResultsImg} alt={lang[clang].alt.no_results}/>
            { !isHeadingsDetails && (
                <div className="results__no-results--suggestions-container">
                    <h3 className="results__no-results--suggestions">
                        <img className="results__no-results--suggestions-img" src={suggestionsImg} alt="" />
                        <img className="results__no-results--suggestions-img contrast" src={suggestionsImgContrast} alt=""/>
                        {lang[clang].results.no_results_suggestions}
                    </h3>
                    <ul 
                        dangerouslySetInnerHTML={{__html: lang[clang].results.no_results_desc}} 
                        className="results__no-results--desc"
                    />
                </div>
            )}
        </div>
    );
};

NoSearchResults.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(NoSearchResults);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/NoSearchResults.js